// extracted by mini-css-extract-plugin
export var dayLabel = "_i0-0";
export var pickerDisabled = "_i0-1";